import { createReducer } from "typesafe-actions";

import { Deal } from "@mapmycustomers/shared/types/entity";

import AssociationsState from "@app/store/associations/AssociationsState";
import { DEFAULT_ASSOCIATIONS_STATE } from "@app/store/associations/const";
import FileListItem from "@app/types/FileListItem";

import {
  Actions,
  changeAssociatedEntities,
  clearAllUploadedDealFiles,
  initializeEditStageModal,
  removeDealFile,
  updateDeal,
  uploadDealFiles,
} from "./actions";

export interface EditStageModalState {
  associations: AssociationsState;
  filesAdded: FileListItem[];
  filesDeleting: boolean;
  filesUploading: boolean;
  loading: boolean;
  originalDeal?: Deal;
}

const initialState: EditStageModalState = {
  associations: DEFAULT_ASSOCIATIONS_STATE,
  filesAdded: [],
  filesDeleting: false,
  filesUploading: false,
  loading: false,
};

const editStageModal = createReducer<EditStageModalState, Actions>(initialState)
  .handleAction(initializeEditStageModal, (state, { payload }) => ({
    ...state,
    associations: {
      ...state.associations,
      associatedCompany: payload.account,
      associatedPerson: payload.contact,
    },
    filesAdded: [],
    originalDeal: payload,
  }))
  .handleAction(updateDeal.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(updateDeal.success, (state, action) => ({
    ...state,
    ...action.payload,
    loading: false,
  }))
  .handleAction(updateDeal.failure, (state) => ({ ...state, loading: false }))
  .handleAction(changeAssociatedEntities.request, (state, { payload }) => ({
    ...state,
    associations: {
      ...state.associations,
      associatedCompany:
        "company" in payload ? payload.company : state.associations.associatedCompany,
      associatedPerson: "person" in payload ? payload.person : state.associations.associatedPerson,
      availableLoading: true,
    },
  }))
  .handleAction(changeAssociatedEntities.success, (state, { payload }) => ({
    ...state,
    associations: { ...state.associations, ...payload, availableLoading: false },
  }))
  .handleAction(changeAssociatedEntities.failure, (state) => ({
    ...state,
    associations: { ...state.associations, availableLoading: false },
  }))
  .handleAction(uploadDealFiles.request, (state) => ({
    ...state,
    filesUploading: true,
  }))
  .handleAction(uploadDealFiles.success, (state, { payload }) => ({
    ...state,
    filesAdded: [...state.filesAdded, ...payload],
    filesUploading: false,
  }))
  .handleAction(uploadDealFiles.failure, (state) => ({ ...state, filesUploading: false }))
  .handleAction(removeDealFile.request, (state) => ({ ...state, filesDeleting: true }))
  .handleAction(removeDealFile.success, (state, action) => ({
    ...state,
    //Removing the deleted file from store
    filesAdded: state.filesAdded.filter((file) => file.uploadedFile?.id !== action.payload),
    filesDeleting: false,
  }))
  .handleAction(removeDealFile.failure, (state) => ({
    ...state,
    filesDeleting: false,
  }))
  .handleAction(clearAllUploadedDealFiles, (state) => ({
    ...state,
    filesAdded: [],
    filesUploading: false,
  }));

export * from "./selectors";
export type EditStageModalActions = Actions;

export default editStageModal;
